import { array, defineAction, number, object, string } from '~/prix'
import appSebraeAttendanceMetricsAction from './appSebraeAttendanceMetrics.action.json'

const appSebraeNewAttendanceDefinition = defineAction({
  ...appSebraeAttendanceMetricsAction,
  input: object({}),
  output: object({
    counts: object({
      currentYear: number(),
      allTime: number(),
      yearly: object({
        year: number(),
      }).isOptional(),
    }),
    warnings: array(
      object({
        message: string(),
      }),
    ).isOptional(),
  }),
})

export default appSebraeNewAttendanceDefinition
